(() => {
  const listedHolidays = {
    2026: ['01-01','01-19','02-16','05-25','06-19','07-03','07-04','09-07','10-12','11-11','11-26','12-25'],
    2027: ['01-01','01-18','02-15','05-31','06-18','06-19','07-04','07-05','09-06','10-11','11-11','11-25','12-24','12-25','12-31']
  };
  const key = date => date.toISOString().slice(0,10);
  const nthMonday = (year, month, n) => {
    const first = new Date(Date.UTC(year,month,1));
    return new Date(Date.UTC(year,month,1+(8-first.getUTCDay())%7+7*(n-1)));
  };
  const holidaysFor = year => {
    if (listedHolidays[year]) return new Set(listedHolidays[year].map(day => `${year}-${day}`));
    const dates = [nthMonday(year,0,3),nthMonday(year,1,3),nthMonday(year,8,1),nthMonday(year,9,2)];
    const mayLast = new Date(Date.UTC(year,4,31));
    mayLast.setUTCDate(31-(mayLast.getUTCDay()+6)%7);dates.push(mayLast);
    const novemberFirst = new Date(Date.UTC(year,10,1));
    dates.push(new Date(Date.UTC(year,10,1+(11-novemberFirst.getUTCDay())%7+21)));
    for (const [month,day] of [[0,1],[5,19],[6,4],[10,11],[11,25],[12,1]]) {
      const actual = new Date(Date.UTC(year,month,day));dates.push(actual);
      const observed = new Date(actual);
      if(actual.getUTCDay()===6)observed.setUTCDate(observed.getUTCDate()-1);
      if(actual.getUTCDay()===0)observed.setUTCDate(observed.getUTCDate()+1);
      dates.push(observed);
    }
    return new Set(dates.map(key));
  };
  const calendarDay = value => {
    if(typeof value==='string' && /^\d{4}-\d{2}-\d{2}$/.test(value))return new Date(value+'T00:00:00Z');
    const parts = new Intl.DateTimeFormat('en-US',{timeZone:'America/New_York',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(value);
    const part = type => parts.find(x=>x.type===type).value;
    return new Date(`${part('year')}-${part('month')}-${part('day')}T00:00:00Z`);
  };
  const estimate = (orderedAt = new Date()) => {
    const date = calendarDay(orderedAt);
    let count=0;
    while(count<9){
      date.setUTCDate(date.getUTCDate()+1);
      if(date.getUTCDay()!==0 && date.getUTCDay()!==6 && !holidaysFor(date.getUTCFullYear()).has(key(date)))count++;
    }
    return date;
  };
  const format = date => new Intl.DateTimeFormat('en-US',{timeZone:'UTC',month:'short',day:'numeric'}).format(date);
  const update = (root=document) => {
    const text=format(estimate());
    const targets=[...(root.matches?.('[data-mc-delivery-date]')?[root]:[]),...root.querySelectorAll('[data-mc-delivery-date]')];
    targets.forEach(el=>{if(el.textContent!==text)el.textContent=text;});
    root.querySelectorAll('.delivery-date-text').forEach(el=>{el.textContent=`${el.dataset.prefix || 'Order now to receive by'} ${text}`;});
  };
  window.mcDelivery = {estimate,format,update,holidaysFor};
  document.addEventListener('DOMContentLoaded',()=>update());
  document.addEventListener('shopify:section:load',()=>update());
  document.addEventListener('visibilitychange',()=>{if(!document.hidden)update();});
  window.addEventListener('pageshow',()=>update());
  new MutationObserver(records=>records.forEach(record=>record.addedNodes.forEach(node=>{
    if(node.nodeType===1 && (node.matches('[data-mc-delivery-date],.delivery-date-text') || node.querySelector('[data-mc-delivery-date],.delivery-date-text')))update(node);
  }))).observe(document.documentElement,{childList:true,subtree:true});
})();
